import { render, staticRenderFns } from "./SolicitacaoRespostaListaDetails.vue?vue&type=template&id=07d64104"
import script from "./SolicitacaoRespostaListaDetails.vue?vue&type=script&lang=js"
export * from "./SolicitacaoRespostaListaDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports